import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CHAT_ICON from "../../assets/chatIcon.svg";
import { AppContext } from "../../utils/Context/AppContext";
import doubleArrowIcon from "../../assets/doubleArrowIcon.svg";
import { BsThreeDotsVertical } from "react-icons/bs";
import newDeleteIcon from "../../assets/newDeleteIcon.svg";
import { handleDeleteSession } from "../../utils/services/api";
import toast from "react-hot-toast";
import { LuInfo } from "react-icons/lu";
import { FiLogOut } from "react-icons/fi";
import { useMsal } from "@azure/msal-react";

const SideBar = ({ flag, setFlag, setShowMobileSideBar }) => {
  const navigate = useNavigate();
  const ref = useRef();
  const { appData, dispatch } = useContext(AppContext);
  const [hoverState, setHoverState] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [today, setToday] = useState([]);
  const [thisWeek, setThisWeek] = useState([]);
  const [previous, setPrevious] = useState([]);
  const [newConv, setNewConv] = useState(false);
  const [activeMenuIndexForThisWeek, setActiveMenuIndexForThisWeek] =
    useState(null);
  const [activeMenuIndexForPrevious, setActiveMenuIndexForPrevious] =
    useState(null);
  const [activeMenuIndexForToday, setActiveMenuIndexForToday] = useState(null);
  const [searchParams] = useSearchParams();
  const { accounts, instance } = useMsal();
  const isMobile = window.innerWidth < 640;

  // const account = accounts[0]; // Get the first (active) MSAL account
  // const displayName =
  //   account?.name || localStorage.getItem("userName") || "User";
  // const userEmail =
  //   account?.username || localStorage.getItem("userId") || "example@email.com";

  const getConvo = async () => {
    try {
      let response = await appData.getConvo();
      if (window.location.search.includes("?new_conversation")) {
        navigate(`${window.location.pathname}?new_conversation`);
        return;
      }
      if (window.location.pathname === "/chat") {
        if (
          response.data.data_driven?.length === 0 ||
          window.location.search.includes("?new_conversation")
        ) {
          navigate(`${window.location.pathname}?new_conversation`);
        } else {
          if (window.location.search.includes("?conversation_id=")) {
            navigate(`${window.location.pathname}${window.location.search}`);
          } else {
            navigate(`${window.location.pathname}?new_conversation`);
          }
        }
        setConversations(appData?.dataDrivenChat);
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (window.location.pathname === "/chat") {
      if (
        appData?.dataDrivenChat?.length === 0 &&
        !searchParams.get("conversation_id")
      ) {
        navigate(`${window.location.pathname}?new_conversation`);
      }
      setConversations(appData?.dataDrivenChat);
    }
  }, [appData?.dataDrivenChat]);

  useEffect(() => {
    if (window.innerWidth < 635) {
      dispatch({ type: "hideSidebar", payload: true });
    }
  }, []);

  useEffect(() => {
    if (flag) {
      dispatch({
        type: "DATA_PAGE_LOADER",
        payload: true,
      });
      setFlag(false);
    }
    try {
      getConvo();
    } catch (err) {}
  }, []);

  HandleClickOutside(ref, () => {
    setActiveMenuIndexForPrevious(null);
    setActiveMenuIndexForThisWeek(null);
    setActiveMenuIndexForToday(null);
  });

  useEffect(() => {
    const today = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(today.getDate() - 7);

    const todayConversations = [];
    const thisWeekConversations = [];
    const remainingConversations = [];

    conversations?.forEach((item) => {
      const conversationDate = new Date(item?.date_created);
      if (isSameDay(conversationDate, today)) {
        todayConversations.push(item);
      } else if (conversationDate >= oneWeekAgo && conversationDate < today) {
        thisWeekConversations.push(item);
      } else {
        remainingConversations.push(item);
      }
    });

    setToday(todayConversations.reverse());
    setThisWeek(thisWeekConversations.reverse());
    setPrevious(remainingConversations.reverse());
  }, [conversations]);

  function isSameDay(date1, date2) {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  useEffect(() => {
    if (window.location.pathname === "/chat") {
      setConversations(appData?.dataDrivenChat);
    }

    if (window.location.search === "?new_conversation") {
      setNewConv(true);
    } else {
      setNewConv(false);
    }
  }, [window.location.pathname, searchParams]);

  const handleDelete = async (id) => {
    try {
      // Proceed with the API call
      const response = await handleDeleteSession(id);

      if (response.status === 200) {
        toast.success("Successfully Deleted!");
        getConvo();
        navigate(`${window.location.pathname}?new_conversation`);
      } else {
        toast.error("Failed to delete the session.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong.");
    }
  };

  const handleLogout = async () => {
    setShowMobileSideBar(false);

    const accounts = instance.getAllAccounts();

    try {
      if (accounts && accounts.length > 0) {
        await instance.logoutRedirect({
          account: accounts[0],
          postLogoutRedirectUri: `${window.location.origin}/logout-success`, // 🔁 point to your LogoutSuccess component
        });
      } else {
        // No MSAL account — just clear and redirect
        clearAppStorage();
        navigate("/");
      }
    } catch (error) {
      console.error("Logout failed:", error);
      clearAppStorage();
      navigate("/");
    }
  };
  // Utility function to clean up app-specific storage
  const clearAppStorage = () => {
    localStorage.removeItem("userName");
    localStorage.removeItem("idToken");
    localStorage.removeItem("loginType");
    localStorage.removeItem("userId");
    sessionStorage.clear();
  };

  return (
    <div className="sidebar h-full flex flex-col sm:w-[16rem] border-r-[1px] border-[#D6D6D6] bg-[#F6F8FB]">
      {/* Close Button for Desktop */}
      <button
        className="hidden sm:flex h-[30px] max-w-[30px] mb-3 items-center justify-center text-[#444791] rounded-[6px] text-sm absolute right-[-18px] top-[10px] transform translate-x-[10px]"
        onClick={() => dispatch({ type: "hideSidebar", payload: false })}
      >
        <img src={doubleArrowIcon} alt="" />
      </button>

      {/* Main Scrollable Content */}
      <div className="flex-1 overflow-y-auto ps-[12px] pt-[9px] pe-[7px]">
        {/* New Chat */}
        {newConv && (
          <div className="flex justify-between gap-4 items-center py-[9px] px-[14px] cursor-pointer rounded-[3px]">
            <div className="flex items-center gap-4 w-full">
              <img className="h-[14px]" src={CHAT_ICON} alt="" />
              <p className="text-ellipsis overflow-hidden whitespace-nowrap text-sm text-[#000000]">
                New Chat
              </p>
            </div>
          </div>
        )}

        {/* Today Section */}
        {today?.length > 0 && (
          <>
            <div className="text-[#A3A3A3] text-sm pb-[0.5rem] px-[14px]">
              Today
            </div>
            {today.map((item, i) => {
              const isSelected =
                searchParams.get("conversation_id") == item?.session_id;
              const isHovered = hoverState === i;

              return (
                <div
                  key={i}
                  className="flex justify-between items-center px-[8px] cursor-pointer rounded-[3px] mb-1"
                  onMouseEnter={() => setHoverState(i)}
                  onMouseLeave={() => setHoverState(null)}
                  onClick={() => {
                    if (window.innerWidth < 635)
                      dispatch({ type: "TOGGLE_MOBILE_SIDEBAR" });
                    navigate(
                      `${window.location.pathname}?conversation_id=${item?.session_id}`
                    );
                  }}
                >
                  <div
                    className={`flex items-center justify-between gap-4 py-2 rounded px-3 w-full ${
                      isSelected
                        ? "bg-[#EFFBFF] border border-[#00AEEF]"
                        : isHovered
                        ? "hover:bg-[#EFFBFF] hover:border hover:border-[#00AEEF]"
                        : ""
                    }`}
                  >
                    <div className="w-[140px] flex items-center gap-4">
                      <img className="h-[14px]" src={CHAT_ICON} alt="" />
                      <p
                        title={item?.session_name}
                        className="truncate text-sm text-[#000000]"
                      >
                        {item?.session_name || "Chat Name"}
                      </p>
                    </div>
                    <div className="relative w-[10px]">
                      <BsThreeDotsVertical
                        className="cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveMenuIndexForPrevious(null);
                          setActiveMenuIndexForThisWeek(null);
                          setActiveMenuIndexForToday(
                            activeMenuIndexForToday === i ? null : i
                          );
                        }}
                      />
                      {activeMenuIndexForToday === i && (
                        <div className="absolute right-[-15px] top-6 w-[100px] bg-[#F5F5F5] border border-[#D5D5D5] shadow-lg rounded-[4px] z-50">
                          <div className="px-4 py-1 flex items-center">
                            <img src={newDeleteIcon} />
                            <button
                              ref={ref}
                              className="text-[#F40101] text-[12px] font-semibold w-full text-left px-3 py-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(item?.session_id);
                                setActiveMenuIndexForToday(null);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {/* This Week Section */}
        {thisWeek?.length > 0 && (
          <>
            <div className="text-[#A3A3A3] text-sm px-[14px] mt-2">
              This week
            </div>
            {thisWeek.map((item, i) => {
              const index = today.length + i;
              const isSelected =
                searchParams.get("conversation_id") == item?.session_id;
              const isHovered = hoverState === index;

              return (
                <div
                  key={i}
                  className="flex justify-between items-center px-[8px] cursor-pointer rounded-[3px] mb-1"
                  onMouseEnter={() => setHoverState(index)}
                  onMouseLeave={() => setHoverState(null)}
                  onClick={() => {
                    if (window.innerWidth < 635)
                      dispatch({ type: "TOGGLE_MOBILE_SIDEBAR" });
                    navigate(
                      `${window.location.pathname}?conversation_id=${item?.session_id}`
                    );
                  }}
                >
                  <div
                    className={`flex items-center justify-between gap-4 py-2 rounded px-3 w-full ${
                      isSelected
                        ? "bg-[#EFFBFF] border border-[#00AEEF]"
                        : isHovered
                        ? "hover:bg-[#EFFBFF] hover:border hover:border-[#00AEEF]"
                        : ""
                    }`}
                  >
                    <div className="w-[140px] flex items-center gap-4">
                      <img className="h-[14px]" src={CHAT_ICON} alt="" />
                      <p
                        title={item?.session_name}
                        className="truncate text-sm text-[#000000]"
                      >
                        {item?.session_name || "Chat Name"}
                      </p>
                    </div>
                    <div className="relative w-[10px]">
                      <BsThreeDotsVertical
                        className="cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveMenuIndexForPrevious(null);
                          setActiveMenuIndexForToday(null);
                          setActiveMenuIndexForThisWeek(
                            activeMenuIndexForThisWeek === i ? null : i
                          );
                        }}
                      />
                      {activeMenuIndexForThisWeek === i && (
                        <div className="absolute right-[-15px] top-6 w-[100px] bg-[#F5F5F5] border border-[#D5D5D5] shadow-lg rounded-[4px] z-50">
                          <div className="px-4 py-1 flex items-center">
                            <img src={newDeleteIcon} />
                            <button
                              ref={ref}
                              className="text-[#F40101] text-[12px] font-semibold w-full text-left px-3 py-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(item?.session_id);
                                setActiveMenuIndexForThisWeek(null);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}

        {/* Previous Section */}
        {previous?.length > 0 && (
          <>
            <div className="text-[#A3A3A3] text-sm px-[14px] mt-2">
              Previous
            </div>
            {previous.map((item, i) => {
              const index = today.length + thisWeek.length + i;
              const isSelected =
                searchParams.get("conversation_id") == item?.session_id;
              const isHovered = hoverState === index;

              return (
                <div
                  key={i}
                  className="flex justify-between items-center px-[8px] cursor-pointer rounded-[3px] mb-1"
                  onMouseEnter={() => setHoverState(index)}
                  onMouseLeave={() => setHoverState(null)}
                  onClick={() => {
                    if (window.innerWidth < 635)
                      dispatch({ type: "TOGGLE_MOBILE_SIDEBAR" });
                    navigate(
                      `${window.location.pathname}?conversation_id=${item?.session_id}`
                    );
                  }}
                >
                  <div
                    className={`flex items-center justify-between gap-4 py-2 rounded px-3 w-full ${
                      isSelected
                        ? "bg-[#EFFBFF] border border-[#00AEEF]"
                        : isHovered
                        ? "hover:bg-[#EFFBFF] hover:border hover:border-[#00AEEF]"
                        : ""
                    }`}
                  >
                    <div className="w-[140px] flex items-center gap-4">
                      <img className="h-[14px]" src={CHAT_ICON} alt="" />
                      <p
                        title={item?.session_name}
                        className="truncate text-sm text-[#000000]"
                      >
                        {item?.session_name || "Chat Name"}
                      </p>
                    </div>
                    <div className="relative w-[10px]">
                      <BsThreeDotsVertical
                        className="cursor-pointer"
                        onClick={(e) => {
                          e.stopPropagation();
                          setActiveMenuIndexForThisWeek(null);
                          setActiveMenuIndexForPrevious(
                            activeMenuIndexForPrevious === i ? null : i
                          );
                        }}
                      />
                      {activeMenuIndexForPrevious === i && (
                        <div className="absolute right-[-15px] top-6 w-[100px] bg-[#F5F5F5] border border-[#D5D5D5] shadow-lg rounded-[4px] z-50">
                          <div className="px-4 py-1 flex items-center">
                            <img src={newDeleteIcon} />
                            <button
                              ref={ref}
                              className="text-[#F40101] text-[12px] font-semibold w-full text-left px-3 py-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(item?.session_id);
                                setActiveMenuIndexForPrevious(null);
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>

      {/* Footer only in Mobile */}
      {isMobile && (
        <div className="h-[80px] border-t border-[#D6D6D6] px-6 py-2 text-sm text-[#242424] font-normal">
          <button className="py-1 flex gap-2 items-center w-full hover:underline font-bold">
            <LuInfo color="#242424" size={16} /> Help
          </button>
          <button
            onClick={handleLogout}
            className="py-1 flex gap-2 items-center w-full hover:underline font-bold"
          >
            <FiLogOut color="#242424" size={16} /> Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default SideBar;

export function HandleClickOutside(ref, onClickOutside) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, onClickOutside]);
}
